import { localTrackersStore } from './local';
import { supabaseTrackersStore } from './supabase';
import { isSupabaseConfigured, getSupabase } from '@/lib/supabase';

// Use Supabase if configured, otherwise fall back to localStorage
const useSupabase = isSupabaseConfigured() && !!getSupabase();
console.log('🔍 TrackersStore adapter selection:', {
  isSupabaseConfigured: isSupabaseConfigured(),
  hasSupabaseClient: !!getSupabase(),
  usingSupabase: useSupabase,
});

export const trackersStore = useSupabase ? supabaseTrackersStore : localTrackersStore;
export type TrackersStore = typeof trackersStore;
